import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Custom PrivateRoute component
 *
 * Author: Muhammad Rooman 
 * Date: 20 August, 2024
 */
const PrivateRoute = ({ element, isAuthenticated }) => {
    return isAuthenticated ? element : <Navigate to="/login" replace />;
};

export default PrivateRoute;
